module.exports = "img/menu.e7371a9.png";